import { useContext, useMemo, useState } from "react";

import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import Overlay from "../Componentes/Overlay";
import SideMenu from "../Componentes/SideMenu";
import SideMenuBtn from "../Componentes/SideMenuBtn";
import AtestadosContent from "../Modulos/AtendimentoAmb/Atestados/Content";
import ModalNovoAtestado from "../Modulos/AtendimentoAmb/Atestados/ModalNovoAtestado";
import { AuthContext } from "../Auth/AuthProvider";
import { VerifyPermission } from "../Funcoes/VerifyPermission";
import { useModal } from "../contexts/ModalContext";

const PERMISSAO_BASE = { modulo: "ssma", submodulo: "atendimento-amb" };

const AtendimentoAmbAtestados = () => {
    const { openModal, closeModal, isModalOpen } = useModal();
    const { user } = useContext(AuthContext);
    const [listRefreshKey, setListRefreshKey] = useState(0);

    const podeLancarEditar = useMemo(
        () => VerifyPermission(user, { ...PERMISSAO_BASE, funcao: "atestados-lancar-editar" }),
        [user]
    );

    const openSidebar = () => openModal("atestadosSidebar");

    const openNovoAtestado = () => {
        if (!podeLancarEditar) return;
        closeModal();
        openModal("atestadoNovo");
    };

    return (
        <>
            <NavBar
                title="ATENDIMENTO AMBULATORIAL — ATESTADOS"
                goBackOnePage
                setSideBar={openSidebar}
            />
            <GenericBody>
                <AtestadosContent refreshKey={listRefreshKey} />
            </GenericBody>

            {isModalOpen("atestadosSidebar") && (
                <Overlay state changeContent={closeModal}>
                    <SideMenu>
                        {podeLancarEditar && (
                            <SideMenuBtn
                                button="NOVO ATESTADO"
                                clickFunc={openNovoAtestado}
                            />
                        )}
                    </SideMenu>
                </Overlay>
            )}

            {podeLancarEditar && isModalOpen("atestadoNovo") && (
                <ModalNovoAtestado
                    fechar={closeModal}
                    onSaved={() => setListRefreshKey((k) => k + 1)}
                />
            )}
        </>
    );
};

export default AtendimentoAmbAtestados;
